import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getIntegrationsRelations({ organizationId, filters }) {
    const params = { filters }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/integration-relations`,
      {
        params,
        paramsSerializer(parameters) {
          return qs.stringify(parameters, { arrayFormat: 'brackets' })
        },
      }
    )
  },
}
